import { ComponentType } from "react";

import { bridge } from "@multiweb/reactCore/bridge";
import { IDataSourceAttribute } from "@multiweb/reactCore/datasource";
import { createDataSourceAttribute } from "@multiweb/reactUtils";
import { IDataSourceLOVAttribute, LiteListFrameLOVAttributeComponent } from "../../../../../LOV";
import { LiteListFrameGeneralAttributeProps } from "../../../../LiteListFrameGeneralAttribute";
import { LLFAbstractRenderer } from "./LLFAbstractRenderer";

const { stringToBoolean } = bridge;

export class LLFLOVAttributeRenderer extends LLFAbstractRenderer {
    private readonly _controlString: string = "LOVAttribute";

    public override canRender(element: HTMLElement): boolean {
        return element.getAttribute("data-tscitem") === this._controlString;
    }

    public override get component(): ComponentType<LiteListFrameGeneralAttributeProps> {
        return LiteListFrameLOVAttributeComponent;
    }

    public override getAttributes(element: Element): ReadonlyArray<IDataSourceAttribute> {
        const showAttrs = element.getAttribute("data-showattrs")?.split(";");
        if (!showAttrs) {
            throw new Error("[LOVAttributeRenderer] Data attribute \"showAttrs\" cannot be empty.");
        }

        const attributeName = element.getAttribute("data-attrname") ?? "";
        const datasourceAttributes: IDataSourceAttribute[] = [];

        datasourceAttributes.push(
            this._createDataSourceLOVAttribute(attributeName, showAttrs, {
                locKey: element.getAttribute("data-lockey"),
                displayFormat: element.getAttribute("data-displayformat"),
                hidden: !stringToBoolean(element.getAttribute("data-visible"), true),
                editWindow: element.getAttribute("data-editwindow") ?? undefined,
                attributeRendererKey: this.key,
            }),
        );

        showAttrs?.forEach(showAttrName => {
            const attrName = attributeName + "." + showAttrName;
            datasourceAttributes.push(
                createDataSourceAttribute(attrName, {
                    displayFormat: element.getAttribute("data-displayformat"),
                    hidden: true,
                }),
            );
        });

        return datasourceAttributes;
    }

    /**
     * Vytvoří LOV datasource atribut se zadaným názvem, případně i s dalšími předanými vlastnostmi. Do ostatních vlastností doplní null.
     * @param attributeName Název atributu
     * @param otherParams Další vlastnosti atributu
     */
    private _createDataSourceLOVAttribute(
        attributeName: string,
        showAttrs: string[],
        otherParams?: Partial<Omit<IDataSourceLOVAttribute, "attributeName">>,
    ): IDataSourceLOVAttribute {
        return {
            ...createDataSourceAttribute(attributeName, otherParams),
            showAttrs,
            editWindow: otherParams?.editWindow,
        };
    }
}
